/* RESPONSIBLE TEAM: team-omni */
import Service, { inject as service } from '@ember/service';
import { postRequest } from 'embercom/lib/inbox/requests';
import type Session from './session';
import type IntlService from 'ember-intl/services/intl';

export default class BroadcastApi extends Service {
  @service declare session: Session;
  @service declare intl: IntlService;

  async createBroadcast(): Promise<string> {
    let payload = {
      app_id: this.session.workspace.id,
      content: { blocks: [] },
      status: 'paused',
      destinations: [],
      sender_id: this.session.teammate.id,
      title: this.intl.t('outbound.broadcast.untitled-title'),
      scheduled_activation: null,
    };

    let response = await postRequest('/ember/broadcast', payload);
    let json = await response.json();
    let broadcastId = json?.broadcast?.id;

    if (!broadcastId) {
      throw new Error('Missing broadcast id in response');
    }

    return broadcastId;
  }
}

declare module '@ember/service' {
  interface Registry {
    broadcastApi: BroadcastApi;
    'broadcast-api': BroadcastApi;
  }
}
